import ReactOnRails from "react-on-rails";
import axios from "axios";

import { addDomLoadedCallback } from "../helper/domHelper";

import TriviaForm from "../trivias/Form";
import TriviaEditor from "../trivias/TriviaForm/editor/Editor";

ReactOnRails.register({
  TriviaForm,
  TriviaEditor,
});

const setAxiosDefaults = () => {
  axios.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest",
    "X-CSRF-TOKEN": document.querySelector("meta[name=\"csrf-token\"]").getAttribute("content"),
  };
};

addDomLoadedCallback(setAxiosDefaults);
